export const isStringArray = (value: unknown) =>
  Array.isArray(value) && value.every(item => typeof item === 'string');
